var _rect, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBadgeBundle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9942_319095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9942_319095)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3 14C2.44444 14 1.97222 13.7958 1.58333 13.3875C1.19444 12.9792 1 12.4833 1 11.9V9.8H3V0H13V11.9C13 12.4833 12.8056 12.9792 12.4167 13.3875C12.0278 13.7958 11.5556 14 11 14H3ZM11 12.6C11.1889 12.6 11.3472 12.5329 11.475 12.3987C11.6028 12.2646 11.6667 12.0983 11.6667 11.9V1.4H4.33333V9.8H10.3333V11.9C10.3333 12.0983 10.3972 12.2646 10.525 12.3987C10.6528 12.5329 10.8111 12.6 11 12.6ZM5 4.9V3.5H11V4.9H5ZM5 7V5.6H11V7H5ZM3 12.6H9V11.2H2.33333V11.9C2.33333 12.0983 2.39722 12.2646 2.525 12.3987C2.65278 12.5329 2.81111 12.6 3 12.6ZM3 12.6H2.33333H9H3Z",
    fill: "#545556"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeBundle);
export default __webpack_public_path__ + "static/media/badge-bundle.783844c2.svg";
export { ForwardRef as ReactComponent };